// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"8e583064","421":"ea873ee1","639":"b4c650d2","879":"4285d960","970":"b4c650d2"}[chunkId] + ".chunk.css";
};